import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Container, Row, Col } from "reactstrap";
import { createSelector } from 'reselect';
import { toggleSelectTemplateModal } from '../../../../../../../slices/modals/reducer';
import Preloader from '../../../../../../../Components/Common/Preloader';
import CustomSelect from '../../../../../../../Components/Common/CustomSelect';
import TemplateCard from './TemplateCard';
import { setTemplateCategories } from '../../../../../../../slices/campaigns/reducer';

function SelectTemplateModal() {
  const dispatch = useDispatch();

  const selectTemplateModalState = createSelector(state => state, state => {
    return {
      modalState: state.Modal.selectTemplateModal,
      isTemplateLoading: state.Campaign.isTemplateLoading,
      templateCategories: state.Campaign.templateCategories,
      templates: state.Campaign.templates
    }
  });
  const { modalState, isTemplateLoading, templateCategories, templates } = useSelector(selectTemplateModalState);
  const [categories, setCategories] = useState([]);
  const [templatesState, setTemplatesState] = useState([]);

  useEffect(() => {
    if (templateCategories) {
      setCategories(templateCategories.map(el => {
        if (el.status) {
          return {
            value: el._id,
            name: el.name,
            status: el.status
          }
        }
      }));
    }
  }, [templateCategories]);

  useEffect(() => {
    if (templates) {
      setTemplatesState(templates);
    }
  }, [templates]);

  function closeModal() {
    dispatch(toggleSelectTemplateModal());
  }

  function handleCategoryChange(item) {
    let filteredTemplates = templatesState.filter(el => el.categoryId === item.value);
    setTemplatesState(filteredTemplates);
  }

  function handleNameChange(e) {
    let value = e.target.value;
    let filteredTemplates = templatesState.filter(el => {
      return el.name.includes(value);
    });
    if (value !== '') {
      setTemplatesState(filteredTemplates);
    } else {
      setTemplatesState(templates);
    }
  }
  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='xl'>
      <ModalHeader className='p-3' toggle={closeModal}>Select Template</ModalHeader>
      <ModalBody className='px-3 pt-2'>
        {isTemplateLoading ?
           <Preloader isComponentLoader={true} />
           :
          <>
            <div className='w-100 p-3 d-flex align-items-center justify-content-between shadow rounded'>
              <div className='form-icon'>
                <Input type='text' className='form-control form-control-icon' placeholder='Search for templates' onChange={(e) => handleNameChange(e)} />
                <i className='ri-search-line search-icon text-muted'></i>
              </div>
              <CustomSelect placeholder='Select Categories' className='w-auto form-select ms-auto me-0' options={categories} onChange={(item) => handleCategoryChange(item)} />
            </div>
            <div className='w-100 mt-3' fluid>
              <Row>
                {(templatesState || []).map((item, idx) => {
                  return (
                    <Col xl={4} lg={6} key={idx}>
                      <TemplateCard template={item} category={categories.find(el => el.value === item.categoryId)?.name} />
                    </Col>
                  )
                })}

              </Row>
            </div>
          </>
        }
      </ModalBody>
      <ModalFooter className='py-3 border-top'>
        <button className='btn btn-light' onClick={closeModal}>Close</button>
      </ModalFooter>
    </Modal>
  )
}

export default SelectTemplateModal
